import { render, staticRenderFns } from "./ShareBetgame.vue?vue&type=template&id=e638a7a4&scoped=true"
import script from "./ShareBetgame.vue?vue&type=script&lang=js"
export * from "./ShareBetgame.vue?vue&type=script&lang=js"
import style0 from "./ShareBetgame.vue?vue&type=style&index=0&id=e638a7a4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e638a7a4",
  null
  
)

export default component.exports